/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ContentMasterWorkspacePlatformView = {
    /**
     * API source identifier — `plattform:N` for tPlattform-level sources or `shop:N` for tShop-level sources. Send this verbatim as `source`.
     */
    id?: string;
    /**
     * Discriminator: `platform` (kind=platform — tPlattform row) or `shop` (kind=shop — tShop row).
     */
    kind?: ContentMasterWorkspacePlatformView.kind;
    /**
     * dbo.tShop.kShop. Null for kind=platform (no specific shop instance).
     */
    kShop?: number | null;
    /**
     * Resolved dbo.tPlattform.nPlattform. Null only for kind=shop tShops where the platform could not be inferred (no descriptions yet, no fallback). Always set for kind=platform.
     */
    kPlattform?: number | null;
    /**
     * Display name. For kind=platform — tPlattform.cName (e.g. "JTL-Wawi", "Onlineshop", "Amazon DE"). For kind=shop — tShop.cName (e.g. "site1", "Demo Shop").
     */
    name?: string;
    /**
     * For kind=platform — tPlattform.nTyp. For kind=shop — tShop.nTyp.
     */
    nTyp?: number;
    /**
     * Human-readable category. For kind=platform: "Master (JTL-Wawi)" / "Onlineshop (default)" / "Plattform". For kind=shop: "Onlineshop" / "Drittshop" / "B2B" / "Unicorn" / "Filiale" / "BI" / "Marktplatz" / "Unknown" — mirrors JTL UI Verkaufskanaltyp first part.
     */
    nTypLabel?: string;
    /**
     * For kind=platform — always true (tPlattform has no nAktiv flag). For kind=shop — `dbo.tShop.nAktiv = 1`.
     */
    active?: boolean;
    /**
     * tPlattform.cName for the resolved platform. Mirrors `name` for kind=platform; for kind=shop this is the platform that the shop runs on (may be null when not yet inferable).
     */
    plattformName?: string | null;
    /**
     * tPlattform.cID for the resolved platform.
     */
    plattformCId?: string | null;
};
export namespace ContentMasterWorkspacePlatformView {
    /**
     * Discriminator: `platform` (kind=platform — tPlattform row) or `shop` (kind=shop — tShop row).
     */
    export enum kind {
        PLATFORM = 'platform',
        SHOP = 'shop',
    }
}

